<template>
  <span class="icon" v-on:click="$emit('click')">
      <font-awesome-icon v-bind:icon="icon" />
  </span>
</template>

<script>
export default {
  name: 'ErranditeIcon',
  props: {
    icon: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_variables.scss";

</style>
